import React from 'react'
import { Grid } from '@mui/material'
import ProfileMenu from '../../components/ProfileMenu'
import ProfileHistoryBet from '../../components/ProfileHistoryBet'

const BetslipHistoryPage = () => {
  return (
    <>
      <Grid container spacing={2} sx={{ maxWidth: '900px', margin: 'auto' }}>
        <Grid item md={3}>
          <ProfileMenu />
        </Grid>
        <Grid item md={9}>
          <ProfileHistoryBet />
        </Grid>
      </Grid>
    </>
  )
}

export default BetslipHistoryPage